/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1SerieIdMutationRequest,
  PutApiV1SerieIdMutationResponse,
  PutApiV1SerieIdPathParams,
  PutApiV1SerieId400,
  PutApiV1SerieId401,
  PutApiV1SerieId404,
  PutApiV1SerieId500,
} from "../../types/serieRegistroController/PutApiV1SerieId.ts";
import { buildFormData } from "../../.kubb/config.ts";

function getPutApiV1SerieIdUrl(id: PutApiV1SerieIdPathParams["id"]) {
  const res = { method: "PUT", url: `/api/v1/serie/${id}` as const };
  return res;
}

/**
 * @description Atualiza uma série (multipart/form-data). Atualiza título/resumo no idioma corrente, sincroniza as turmas e permite substituir ou remover a imagem de capa. **(Requer Authorization para autenticação)**
 * @summary Atualizar série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:id}
 */
export async function putApiV1SerieId(
  id: PutApiV1SerieIdPathParams["id"],
  data?: PutApiV1SerieIdMutationRequest,
  config: Partial<RequestConfig<PutApiV1SerieIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;
  const formData = buildFormData(requestData);
  const res = await request<
    PutApiV1SerieIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerieId400
      | PutApiV1SerieId401
      | PutApiV1SerieId404
      | PutApiV1SerieId500
    >,
    PutApiV1SerieIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1SerieIdUrl(id).url.toString(),
    data: formData as FormData,
    ...requestConfig,
  });
  return res.data;
}
